<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon size="24px" v-bind="attrs" v-on="on" @click="setData">
            mdi-magnify
        </v-icon>
      </template>
            <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <div class="d-flex justify-space-between align-center">
                  <span class="headline grey--text text--darken-4">Detalhes do usuário</span>
                  <v-icon size="24px" class="pointer" @click="dialog = false;deleteConfirm = false;">
                    mdi-close
                  </v-icon>
                </div>
              </v-col>
            </v-row>
             <v-form
              ref="form"
              v-model="valid"
            >
              <v-row>
                <v-col cols="12">
                  <v-text-field label="Nome" v-model="name" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="Email" v-model="username" :rules="[rules.required, rules.email]"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="Empresa" v-model="company" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[(password == '') || rules.min]"
                    :type="show ? 'text' : 'password'"
                    name="password"
                    label="Nova Senha"
                    counter
                    @click:append="show = !show"
                    class="fluid"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="passwordConfirm"
                    :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[(password === passwordConfirm) || 'Não confere com a senha informada.']"
                    :type="showConfirm ? 'text' : 'password'"
                    name="confirm-password"
                    label="Confirme sua nova senha"
                    counter
                    @click:append="showConfirm = !showConfirm"
                    class="fluid"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <span class="headline grey--text text--darken-4">Permissões</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-select
                      v-model="channelsSelected"
                      :items="channels"
                      item-text="name"
                      item-value="id"
                      label="Canais"
                      multiple
                      color="red"
                      :rules="[rules.required]"
                  >
                  <template #selection="{ item }">
                    <v-chip small color="#424242" class="white--text mt-2">{{item.name}}</v-chip>
                  </template>
                  </v-select>
                </v-col>
                <v-col class="d-block">
                  <div class="d-flex align-center justify-space-between" v-for="permission in permissions" :key="permission.id">
                    <span class="body-2 grey--text text--darken-4">{{permission.name}}</span>
                    <v-switch @change="changePermission($event, permission.id)" :input-value="permissionsSelected.indexOf(permission.id) != -1"></v-switch>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex justify-center flex-wrap align-center">
          <v-spacer class="d-none d-md-block"></v-spacer>
            <v-btn
              v-if="!deleteConfirm"
              color="#ef5350"
              class="button-primary mb-4"
              @click="deleteConfirm = true"
              dark
            >
              <span>Excluir usuário</span>
            </v-btn>
            <v-btn
              v-else
              color="#ef5350"
              class="mb-4"
              @click="deleteUser()"
              dark
            >
              <span>CONFIRMAR EXCLUSÃO</span>
            </v-btn>
            <v-btn
              :disabled="!valid"
              color="#fed602"
              @click="updateUser()"
              class="button-primary mr-2 mb-4"
            >
              <v-progress-circular v-if="loading" :indeterminate="true" size="24"></v-progress-circular>
              <span v-else >Salvar</span>
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    props: {
        user: {
        type: Object,
            required: true,
            default: null
        }
    },
    created() {
      this.setData();
      this.getChannels();
      this.getPermissions();
    },
    data: () => ({
      deleteConfirm: false,
      name: '',
      username: '',
      company: '',
      password: '',
      passwordConfirm: '',
      show: false,
      showConfirm: false,
      loading: false,
      notification: {
          active: false,
          description: '',
          type: '',
          closeText: ''
      },
      valid: true,
      rules: {
          required: value => !!value || 'Este campo é obrigatório.',
          min: v => v.length >= 8 || 'Sua senha precisa ter pelo menos 8 caracteres',
          email: v => /.+@.+\..+/.test(v) || 'E-mail inválido'
      },
      switch1: false,
      dialog: false,
      channels: [],
      channelsSelected: [],
      permissions: [],
      permissionsSelected: []
    }),
    methods: {
      setData() {
        this.permissionsSelected = this.user.permissions.map( permission => {
          return permission.id_permission
        }),
        this.channelsSelected = this.user.channel_permissions,
        this.name = this.user.name,
        this.username = this.user.username,
        this.company = this.user.company
      },
      changePermission(event, id) {
        if (event)
          this.permissionsSelected.push(id)
        else 
          this.permissionsSelected.splice(this.permissionsSelected.indexOf(id), 1);
      },
      getChannels() {
        this.$http.get( '/channel/list')
        .then( ( res ) => {
          this.channels = res.data.map(channel => {
            return {
              id: channel.id_youtube_channel,
              name: channel.name
            }
          })
        } ).catch( () => {
          this.notification = {
            active: true,
            description: 'Houve um erro ao buscar os canais.',
            type: 'error',
            closeText: 'Fechar'
          };
        } )
      },
      getPermissions() {
        this.$http.get( '/permission' )
        .then( ( res ) => {
          this.permissions = res.data.map(permission => {
            return {
              id: permission.id_permission,
              name: permission.exhibition_name,
              permission: false
            }
          })
        } ).catch( () => {
          this.notification = {
            active: true,
            description: 'Houve um erro ao buscar as permissões.',
            type: 'error',
            closeText: 'Fechar'
          };
        })
      },
      updateUser() {
        let params = {};
        if (this.password != '') {
          params = {
            name: this.name,
            username: this.username,
            company: this.company,
            password: this.password,
            permissions: this.permissionsSelected,
            channel_permissions: this.channelsSelected
          }
        } else {
          params = {
            name: this.name,
            username: this.username,
            company: this.company,
            permissions: this.permissionsSelected,
            channel_permissions: this.channelsSelected
          }
        }
        this.$http.put( '/user/' + this.user.id_user, params)
        .then( () => {
          this.notification = {
            active: true,
            description: 'Usuário editado com sucesso.',
            type: 'success',
            closeText: 'Fechar'
          },
          this.$emit( 'notification', this.notification );
        } ).catch( () => {
          this.notification = {
            active: true,
            description: 'Houve um erro ao editar usuário, tente novamente.',
            type: 'error',
            closeText: 'Fechar'
          },
          this.$emit( 'notification', this.notification );
        }) .finally(() => {
          this.loading = false,
          this.valid = true,
          this.dialog = false,
          this.deleteConfirm = false,
          this.$emit("getData")
        })
      },
      deleteUser() {
        this.$http.delete( '/user/' + this.user.id_user)
        .then( () => {
          this.notification = {
            active: true,
            description: 'Usuário excluído com sucesso.',
            type: 'success',
            closeText: 'Fechar'
          },
          this.$emit( 'notification', this.notification );
        } ).catch( () => {
          this.notification = {
            active: true,
            description: 'Houve um erro ao excluir usuário, tente novamente.',
            type: 'error',
            closeText: 'Fechar'
          },
          this.$emit( 'notification', this.notification );
        }) .finally(() => {
          this.loading = false,
          this.valid = true,
          this.dialog = false,
          this.deleteConfirm = false,
          this.$emit("getData")
        })
      }
    }
  }
</script>